// Shared vibrant design tokens (matches Landing/Navbar)
export const C = {
  CREAM: "#FBF6EC",
  INK: "#141210",
  CORAL: "#FF5A36",
  GREEN: "#12715A",
  SUN: "#F4B740",
  MUTED: "#8b857b",
  BORDER: "#ece3d0",
};

export const field =
  "w-full px-4 py-3 rounded-xl bg-white border border-[#ece3d0] text-[#141210] placeholder:text-[#b7ad99] focus:border-[#FF5A36] focus:ring-2 focus:ring-[#FF5A36]/20 outline-none transition-colors";

export const card = "bg-white rounded-2xl border border-[#efe7d6]";

export const softShadow = { boxShadow: "0 10px 30px rgba(20,18,16,0.06)" };
export const coralShadow = { boxShadow: "0 12px 30px rgba(255,90,54,0.35)" };

export const btnPrimary =
  "px-7 py-3.5 rounded-full font-bold text-white bg-[#FF5A36] hover:-translate-y-0.5 transition-transform disabled:opacity-60 disabled:translate-y-0 flex items-center justify-center gap-2";

export const btnGhost =
  "px-6 py-3 rounded-full font-bold border-2 border-[#141210] text-[#141210] bg-white hover:bg-black/5 transition-colors flex items-center justify-center gap-2";
